import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { SettingsItem } from 'design-system';
import { IconBoldCalendar, IconHashTag, IconMoneyBill } from 'design-system/icons';
import { useAppSelector } from 'store/hooks';
import { selectFeatureFlag } from 'reducers/selectors';
import { OrderType } from '../types';
const SelectOrderTypeModalContent = ({ symbol, closeModal, hasRecurringBuy, onSelectOrderType, }) => {
    const colors = useColors();
    const buyInShares = useAppSelector((store) => selectFeatureFlag(store, 'buy_in_shares').value);
    const isMarketClosed = useAppSelector((store) => store.unpersistedInvestReducer.isMarketClosed);
    const handleSelect = useCallback((orderType) => () => {
        onSelectOrderType(orderType);
        closeModal();
    }, [closeModal, onSelectOrderType]);
    return (<View>
      <SettingsItem titleFirst onPress={handleSelect(OrderType.MARKET)} title={buyInShares ? 'Buy in pounds' : 'Market order'} icon={<IconMoneyBill color={colors.text.investment}/>} description={symbol ? `Buy $${symbol} in pound amounts, starting at £1` : 'Buy in pound amounts, starting at £1'}/>
      {buyInShares ? (<SettingsItem titleFirst title="Buy in shares" disabled={isMarketClosed} icon={<IconHashTag colorKey="feed"/>} onPress={handleSelect(OrderType.LIMIT)} description={<Text TextThin-14 Secondary>
              Buy{symbol ? ` $${symbol}` : ''} in shares{isMarketClosed ? '. ' : ''}
              {!!isMarketClosed && (<Text TextThin-14 Red>
                  Available when market opens
                </Text>)}
            </Text>} style={isMarketClosed ? styles.disabled : undefined}/>) : null}
      {!!hasRecurringBuy && (<SettingsItem titleFirst title="Recurring order" icon={<IconBoldCalendar colorKey="income"/>} onPress={handleSelect(OrderType.RECURRING)} description={symbol ? `Create a recurring order of $${symbol}` : 'Create a recurring order'}/>)}
    </View>);
};
export default SelectOrderTypeModalContent;
const styles = StyleSheet.create({
    disabled: {
        opacity: 0.5,
    },
});
